import { BodyRenderExternalData } from '~/components/BodyRender/models';
import { fluidGridMapper } from '~/mappers/fluidGrid';

import { SearchResults } from './models';

export const searchResultsMapper = (
  {
    header: {
      mode,
      description: { pending, results, noResults, emptyPhrase },
      descriptionSize,
      phraseTag,
      phraseSize,
      hiddenHeadline,
      popularSearchesDescription,
      popularSearchesSize,
    },
    resultsTabButton,
    productTabButton,
    articleTabButton,
    moreResultsButtonLabel,
    moreProductsButtonLabel,
    moreArticlesButtonLabel,
    initialVisibleItems,
    imageSettings,
    fluidGridUI,
    uid,
    ...rest
  }: SearchResults,
  _currentPageUid: string,
  { locale }: BodyRenderExternalData
) => ({
  header: {
    mode,
    description: {
      pending,
      results,
      noResults,
      emptyPhrase,
    },
    descriptionSize: descriptionSize?.toLowerCase(),
    phraseTag,
    phraseSize: phraseSize?.toLowerCase(),
    hiddenHeadline,
    popularSearchesDescription,
    popularSearchesSize: popularSearchesSize?.toLowerCase(),
  },
  resultsTab: resultsTabButton,
  productTab: productTabButton,
  articleTab: articleTabButton,
  moreResultsButtonLabel,
  moreProductsButtonLabel,
  moreArticlesButtonLabel,
  initialVisibleItems,
  imageSettings,
  fluidGrid: fluidGridMapper(fluidGridUI[0]),
  locale,
  uid,
  ...rest,
});
